import { Col, Row, Image, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ListGroup from "../component/ListGroup";
import TableComp from "../component/Table";
import { useEffect, useState, useCallback } from "react";
import { StarDots } from "../component/ActionRow";
import { HiPhone } from "react-icons/hi2";
import { TiLocation } from "react-icons/ti";
import LinkDriverList from "../component/LinkDriverList";
import GoalAchievedCard from "../component/GoalAchievedCard";
import NavLink from "../component/NavLink";
import { useLocation, useNavigate } from "react-router-dom";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ReactLoading from "react-loading";
import SessionUtil from "../util/SessionUtil";
import Banner from "../component/Banner";
import CalendarComp from "../component/CalendarComp";
import Filter from "../component/Filter";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // مهم جداً
const CustomRow = ({
  rowData,
  columnNames,
  handleStar,
  handleClickRow,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index} className="cursor-pointer">
          {columnName === "StoreId" ? (
            <span>#{rowData.Id}</span>
          ) : columnName === "Image" ? (
            rowData?.StoreImage ? (
              <div className="dimension-40">
                <Image
                  alt="image"
                  src={rowData.StoreImage}
                  className="img-fluid cursor-pointer"
                  onClick={() => setIsOpen(true)}
                />
                {isOpen && (
                  <Lightbox
                    mainSrc={rowData.StoreImage}
                    onCloseRequest={() => setIsOpen(false)}
                  />
                )}
              </div>
            ) : (
              <div className="img-empty"></div>
            )
          ) : columnName === "StorePhone" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">
                {rowData?.PhoneNumber
                  ? "+" + rowData.AreaCode + rowData.PhoneNumber
                  : "---"}
              </p>
            </div>
          ) : columnName === "StoreAddress" ? (
            <div className="flex-gap-2">
              <TiLocation size={16} color="#4285F4" />
              <p className="mb-0">
                {rowData?.StoreLocation ? rowData?.StoreLocation : "---"}
              </p>{" "}
            </div>
          ) : columnName === "Status" ? (
            rowData.PaymentStatus === null ? (
              "--"
            ) : rowData.PaymentStatus === "PAID" ? (
              <div className="status status-success">
                <p className="mb-0">{t("Paid")}</p>
              </div>
            ) : (
              <div className="status status-failed">
                <p className="mb-0">{t("Not Paid")}</p>
              </div>
            )
          ) : (
            <p className="mb-0">
              {rowData?.[columnName] ? rowData[columnName] : "---"}
            </p>
          )}
        </td>
      ))}
      <td>
        <StarDots
          isFavorite={rowData.IsTopStore}
          handleClick={() => handleStar(rowData.Id, !rowData.IsTopStore)}
          id={rowData.Id}
          page="store"
          handleClickRow={handleClickRow}
          data={rowData}
        />
      </td>
    </tr>
  );
};

const StoresList = () => {
  const location = useLocation();
  const [pathname, setPathname] = useState(window.location.pathname);
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const [isCheckAll, setIsCheckAll] = useState(false);
  // const [isCheck, setIsCheck] = useState([]);
  const [showOffcanvas, setShowOffcanvas] = useState(true);
  const [sortedData, setSortedData] = useState([]);
  const columnNames = [
    "StoreId",
    "Image",
    "StoreNameEn",
    "StoreNameAr",
    "StorePhone",
    "StoreAddress",
    "Status",
    
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
  const [dateActive, setDateActive] = useState();
  const [topStore, setTopStore] = useState([]);
  const [isTopStore, setIsTopStore] = useState(true);
  const [filter, setFilter] = useState();
  const typeUser = SessionUtil.getTypeUser();

    const [state, setState] = useState([]);
    const [stateId, setStateId] = useState();
    const [stateName, setStateName] = useState();
    const [country, setCountry] = useState();
  const handleFilter = (filter, country, type, stateId, stateName) => {
    setFilter(filter);
    setCountry(country);
    setStateId(stateId);
    setStateName(stateName);
    type !== "country" ?  getApi(filter, stateId) : getApi();
    document.body.classList.remove("bg-offcanvas");
    setShowOffcanvas(true);
  };
  const handleStar = (id, isTopStore) => {
    topStoreApi(id, isTopStore);
  };

  const handleClickRow = (path, type, data) => {
    navigate(`/${path}/${type}/${data.Id}`, {
      
      state: {
        id: data.Id,
        type: type,
        data: data,
      },
    });
  };
  const getApi = useCallback(
    async (filter, stateId) => {
      let params = {
        PageNumber: currentPage,
        PageSize: 10,
        OrderBy: "Id Desc",
        StoresView: {
          CreatedDate: dateActive,
          PaymentStatus: filter,
          StateId: stateId,
        },
      };
      const res = await ApiUtil.postApi(ApiPath.GET_ALL_STORE, params, "POST");
      if (res.IsSuccessfull) {
        const totalPage = Math.ceil(res.Result.RecordCount / 10);
        setSortedData(res.Result.Stores);
        setRecordCount(totalPage);
        setLoading(false);
        !filter && !stateId && setTopStore(res.Result.Stores);
      }
    },
    [currentPage, dateActive]
  );
  useEffect(() => {
    setPathname(location.pathname);
    if (isLoggedIn) {
      getApi();
    }
  }, [location, isLoggedIn, getApi]);

  const topStoreApi = async (id, isTopStore) => {
    setIsTopStore(false);
    let params = {
      StoreId: id,
      IsTopStore: isTopStore,
    };
    const res = await ApiUtil.postApi(ApiPath.TOP_STORE, params, "POST");
    if (res.IsSuccessfull) {
       filter || stateId ? getApi(filter,stateId) :getApi() ;
      setIsTopStore(true);
    }
  };
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleViewAll = () => {
     setFilter();
    setStateId();
    setDateActive();
    getApi();
  };
    const getLocationApi = useCallback(async () => {
      const areaCode = country ? country : "962";
      const res = await ApiUtil.getApi(
        ApiPath.LOCATION + "?AreaCode=" + areaCode
      );
      if (res.IsSuccessfull) {
        setState(res.Result);
      }
    }, [country]);
    useEffect(() => {
      getLocationApi();
    }, [getLocationApi]);
  return (
    <Row className="g-0">
      {!loading ? (
        <>
          <Col lg={8} className="position-relative">
            <ListGroup />
            <Banner />
            <CalendarComp
              dateActive={dateActive}
              setDateActive={setDateActive}
            />
            <div className=" mt-4 d-flex justify-content-between gap-2">
              <p className="title">{t("Stores List")}</p>
              <div className="flex-gap-2">
                <Button className="font-13 btn-orange" onClick={handleViewAll}>
                  {t("View All")}
                </Button>
                <Filter
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    country={country}
                    stateId={stateId}
                     filter={filter}
                  />
                  <Filter
                    type={"country"}
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    filter={filter}
                    country={country}
                  />
                  <Filter
                    type={"state"}
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    filter={filter}
                    data={state}
                    stateId={stateId}
                    stateName={stateName}
                    country={country}
                  />
              </div>
            </div>
            <TableComp
              data={sortedData}
              columnNames={columnNames}
              setSortedData={setSortedData}
              // handleSelectAll={handleSelectAll} isChecked={isCheckAll} handleDelete={handleDelete}
            >
              {sortedData.map((rowData, index) => (
                <CustomRow
                  key={index}
                  rowData={rowData}
                  columnNames={columnNames}
                  // handleClick={handleCheckbox} isChecked={isCheck.includes(rowData.Id)}
                  handleStar={handleStar}
                  handleClickRow={handleClickRow}
                  pathname={pathname}
                />
              ))}
            </TableComp>
            <Pagination
              current={currentPage}
              total={recordCount}
              onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
              extraClassName="justify-content-end"
            />
          </Col>
          <Col md={1}>
            <div className="divider-vertical mx-auto"></div>
          </Col>
          <Col lg={3} className="mt-5">
            <NavLink />
            <LinkDriverList
              title={t("Top Stores")}
              subtitle={t("Keep up to be TOP")}
              data={topStore.filter((item) => item.IsTopStore === true)}
              page="store"
              isTopStore={isTopStore}
              setIsTopStore={setIsTopStore}
            />
            {typeUser === "4" && (
              <GoalAchievedCard
                title={"Capital Mall"}
                page="store"
                // data={goalData}
                percentageTop={60}
              />
            )}
          </Col>
        </>
      ) : (
        <Col lg={12} className="loading-style">
          <ReactLoading
            type={"bars"}
            color={"#c8c8c8"}
            height={"50px"}
            width={"50px"}
          />
        </Col>
      )}
    </Row>
  );
};

export default StoresList;
